import React from 'react';
import PropTypes from 'prop-types';

function NextArrow(props) {
  const {
    className,
    onClick,
    children,
    currentTab,
    totalItems,
    markPendingFocusToSlide,
    shouldMoveFocusOnNextTab,
    clearPendingFocusToSlide,
    moveFocusToCurrentSlide,
    isHomepageCarousel,
  } = props;

  const isSlickDisabled = className && className.includes('slick-disabled');
  const lastIndex = totalItems - 1;
  const shouldDisable = currentTab >= lastIndex || isSlickDisabled;

  const handleClick = (e) => {
    if (shouldDisable) {
      e.preventDefault();
      return;
    }
    markPendingFocusToSlide?.();
    onClick?.(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && !e.shiftKey && shouldMoveFocusOnNextTab?.()) {
      e.preventDefault();
      moveFocusToCurrentSlide?.();
      clearPendingFocusToSlide?.();
    }
  };

  return (
    <button
      type="button"
      className={className}
      aria-label="Próximo slide do carrossel"
      aria-disabled={shouldDisable}
      disabled={shouldDisable}
      onClick={handleClick}
      tabIndex={isHomepageCarousel && shouldDisable ? -1 : 0}
    >
      {children}
    </button>
  );
}

NextArrow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  currentTab: PropTypes.number,
  totalItems: PropTypes.number,
  markPendingFocusToSlide: PropTypes.func,
  shouldMoveFocusOnNextTab: PropTypes.func,
  clearPendingFocusToSlide: PropTypes.func,
  moveFocusToCurrentSlide: PropTypes.func,
  isHomepageCarousel: PropTypes.bool
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const NextArrow = ({prop = val, children = <span className="glyphicon glyphicon-chevron-right" />, onClick = () => null }) =>
  

NextArrow.defaultProps = {
  children: <span className="glyphicon glyphicon-chevron-right" />,
  className: '',
  onClick: () => null,
  currentTab: 0,
  totalItems: 0,
  isHomepageCarousel: false,
};

export default NextArrow;